module.exports = __webpack_public_path__ + "static/focus-1721d7abd636112e7bc9fe2270c7f0e5.webp";